import { useState } from 'react'
import { toast } from 'react-toastify'

import { userAssignmentCodes } from '../api/services/user_assignment_codes'
import {
  FetchResponse,
  SurveyReportScoringRanges,
  SurveyTotalReport
} from '../api/services/user_assignment_codes/types.ts'

export const useSurveyTemplates = () => {
  const [loading, setLoading] = useState<boolean>(true)

  const [surveyReport, setSurveyReport] = useState<SurveyTotalReport | null>()
  const [scoringRanges, setScoringRanges] = useState<SurveyReportScoringRanges[]>([])
  const [error, setError] = useState<string | null>(null)

  const getReport = async (
    assignmentCodeId: number,
    surveyTemplateID: number
  ) => {
    try {
      setLoading(true)
      const response: FetchResponse<SurveyTotalReport> =
        await userAssignmentCodes.getSurveyReport<SurveyTotalReport>(
          assignmentCodeId,
          surveyTemplateID
        )

      if (response.status === 200 && response.data) setSurveyReport(response.data)
      if (response.status === 200 && response.data) setScoringRanges(response.data.scoring_ranges)
      if (response.status !== 200) setError(response.error ?? 'Something went wrong')
    } catch (error) {
      toast.error(error as string)
    } finally {
      setLoading(false)
    }
  }

  return { loading, error, surveyReport, scoringRanges, getReport }
}
